(function() {
  exports.Steps = function(handler) {
    var i, len, ref, ref1, self, step;
    self = this;
    this.getClass = function(data) {
      if (data.id === self.current()) {
        if (data.id === self.final_step.id) {
          return "btn btn-blue spp-final";
        } else {
          return "btn spp-button btn-primary";
        }
      } else if (data.visited() && !data.skipped()) {
        if (data.id === self.final_step.id) {
          return "btn btn-light-blue spp-final";
        } else {
          return "btn spp-button btn-light-green";
        }
      } else {
        if (data.id === self.final_step.id) {
          return "btn spp-final";
        } else {
          return "btn spp-button ";
        }
      }
    };
    this.getText = function(data) {
      if (data.id === self.final_step.id) {
        return "Fit Seed to Field";
      } else {
        return data.step_order;
      }
    };
    this.getEnabled = function(data) {
      return data.visited() || data.skipped();
    };
    this.setCurrent = function(id) {
      var i, len, ref, results, v;
      this.current(id);
      ref = this.steps;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        v = ref[i];
        if (v.id === id) {
          v.visited(true);
          break;
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    this.goToStep = function(step) {
      if (step.id !== self.current()) {
        return handler.goToStep(step.step_order, true);
      }
    };
    this.steps = handler.taffyObjects.steps().get();
    ref = this.steps;
    for (i = 0, len = ref.length; i < len; i++) {
      step = ref[i];
      step.visited = ko.observable(step.visited);
      step.skipped = ko.observable(step.skipped);
    }
    this.steps[0].visited(true);
    this.current = ko.observable((ref1 = handler.curStep) != null ? ref1.num : void 0);
    this.final_step = this.steps[this.steps.length - 1];
    return this;
  };

}).call(this);
